/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

const ViewListOfBasestation = ({ view }) => {
  return (
    <div id="view_access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title my-2">Details</h4>
            <button type="button" className="mr-2 close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div className="modal-body detail p-0">
            <div className="row">
              <div className="col-lg-12 d-flex">
                <div className="col-lg-5 detail-label1">
                  <label className="mt-1">Name</label>
                  <label className="mt-1">Location</label>
                  {/* <label className="mt-1">Device Type</label> */}
                </div>
                <div className="col-lg-7 detail-result1 item-font">
                  <p className="mt-4 mb-2">{view.site_name}</p>
                  <p className="mb-2">{view.location}</p>
                  {/* <p className="mb-2">{view.device_type}</p> */}
                </div>
              </div>

              {/* <div className="col-lg-12 d-flex"> */}
              {/*  <div className="col-lg-5 detail-label3"> */}
              {/*    <label>Number of Connections</label> */}
              {/*  </div> */}
              {/*  <div className="col-lg-7 detail-result2 item-font"> */}
              {/*    <p className="mt-4 mb-2">{view.number_of_connections}</p> */}
              {/*  </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewListOfBasestation;
